module.exports = __webpack_public_path__ + "img/slider_5.08e35cbd.jpg";